import { http } from "../http-common";

const getCropStageCalendarList = (size, itemsPerPage, query) => {
  return http.get(`/crop-stage-calendar?pageNumber=${size}&size=${itemsPerPage}&`+query);
};

const getCropStageCalendarListAll = (size, itemsPerPage, query, config = {}) => {

  return http.get(`/crop-stage-calendar?pageNumber=${size}&size=${itemsPerPage}&${query}`, config);
};


const updateCropStageCalendar = ( data) => {
  return http.put(`/crop-stage-calendar`, data);
};
const getCropYears = (config) => {
  return http.get(`/cropYears`, config);
};
const CropStageCalendarService = {
  getCropStageCalendarList,
  updateCropStageCalendar,
  getCropStageCalendarListAll,
  getCropYears
};

export default CropStageCalendarService;